import { render, staticRenderFns } from "./SimulateAccess.vue?vue&type=template&id=0e3ba274&scoped=true"
import script from "./SimulateAccess.vue?vue&type=script&lang=js"
export * from "./SimulateAccess.vue?vue&type=script&lang=js"
import style0 from "./SimulateAccess.vue?vue&type=style&index=0&id=0e3ba274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3ba274",
  null
  
)

export default component.exports